import { Spin } from "antd";
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import CenterDiv from "./components/CenterDiv/index.tsx";
import { ContextProvider } from "./contexts/workflowContext.tsx";
import "./index.css";
import { setI18NLocaleAction } from "./redux/actions/appStateActions";
import customStore from "./redux/store";
import AnalyticsTrack from "./services/analytics/AnalyticsTrack.tsx";
import { bootstrapDatadogRum } from "./services/datadog";
import Polyfill from "./utils/Polyfill";

const App = lazy(() => import("./App.tsx"));
Polyfill();

if (import.meta.env.DEV) {
  import("@axe-core/react").then(({ default: axe }) => {
    axe(React, ReactDOM, 1000);
  });
}

// Configure Redux Store
const store = customStore(false);
store.dispatch(setI18NLocaleAction());

const loader = (
  <div className="lr-model-backdrop-wrap">
    <CenterDiv>{<Spin size="large" fullscreen />}</CenterDiv>
  </div>
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Suspense fallback={loader}>
    <Provider store={store}>
      <ContextProvider>
        <AnalyticsTrack>
          <App />
        </AnalyticsTrack>
      </ContextProvider>
    </Provider>
  </Suspense>
);

bootstrapDatadogRum();
